import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { AppointmentRequestModel } from '../business-entities/appointmentList-model';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
@Injectable({
  providedIn: 'root'
})

export class ArchivedAppointmentDataService {
  constructor(private dataProvider: DataService,
    private http: HttpClient) {
  }

  GetArchivedAppointmentList(appointmentRequestModel: AppointmentRequestModel): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetArchivedAppointmentList, appointmentRequestModel).toPromise();
  }

  GetAllStatusForArchivedAppointments(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAllStatusForArchivedAppointments, model).toPromise();
  }

  GetAllWorkOrderStatusForArchivedAppointments(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAllWorkOrderStatusForArchivedAppointments, model).toPromise();
  }

  DeleteArchivedAppointment(deleteModel: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.DeleteArchivedAppointment, deleteModel).toPromise();
  }
}
